// extracted by mini-css-extract-plugin
export default {"container":"CS-Admin--container--nEkyAssE","card":"CS-Admin--card--cOPpCZ0k","section":"CS-Admin--section--bfXqM0xi","textInfo":"CS-Admin--textInfo--poR6ecf9"};